import React, { useState, useEffect } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/GridFiltro/StandardActions';
import styled from 'styled-components';
import LoadMask from "../../Utils/LoadMask/LoadMask";
import Modal from '../../components/Modal';
import NavbarModulo from '../../components/NavbarModulo';
import moment from 'moment';
import {  GrPrint  } from 'react-icons/gr';
import { IconContext } from "react-icons";
import { Field, reduxForm } from 'redux-form/immutable';

import {
    AsyncSelectField,
    SelectField,
    renderNumber
} from "../../Utils/renderField/renderField";


function DescuentoList(props){
    const { data, loader, modulo, periodoD, reporteDescuentoHoras, 
            listarPeriodos, periodos, listarColaboradorReporte, loaderRep } = props;
    
    useEffect(() => {
        const { listar, getModulo, leerPeriodoD } = props;    
        listar();
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4]);
        leerPeriodoD(modulo[5],modulo[7]);
    }, [])
    
    const estilo1 = {
        backgroundColor: "#666666", maxHeight: "35px", maxWidth: "35px"
    };
    const [modalReporte, setModalReporte] = useState(false);
    let ruta = window.location.href;
    let datosRt = ruta.split('/');

    const handleOnChange = (e,value) => {
        if (value.length == 4) {
            listarPeriodos(value)
        }
        
    }
    const tipoD = [
        { label: "1RA. QUINCENA", value: "1Q" },
        { label: "2DA. QUINCENA", value: "2Q" },
    ];

    return (
        <div>
            <NavbarModulo
                periodoD={periodoD}
                modulo={modulo}
            />
            <br />
            <h3 className="p-2 bg-secondary title">Descuentos por hora</h3>
            <br />
            <div className="d-flex flex-row justify-content-between mb-2">
                <a
                    href={`/#/rr_hh/${datosRt[5]}/descuento_hora/${datosRt[7]}/crear`}
                    className='btn btn-primary'
                >
                    Crear descuento
                </a>
                <button className='btn btn-dark float-right d-flex justify-content-center' onClick={() => setModalReporte(!modalReporte)} style={estilo1}
                    data-bs-toggle="tooltip" data-bs-placement="left" title="Generar reporte">
                        <i>
                            <IconContext.Provider value={{size: "1.25rem" }}>
                                < GrPrint />
                            </IconContext.Provider>
                        </i>
                </button>
            </div>
            {data &&
                <Grid 
                    hover 
                    striped 
                    data={data}
                    loading={loader} 
                    headerStyle={ { background: 'black' } } 
                    //onPageChange={onPageChange}
                    //onSortChange={onSortChange} 
                >
                    <TableHeaderColumn
                        isKey
                        dataField="codigo"
                        width="150"
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 0}).format(Math.abs(cell));
                        }}
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Código
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="nombre"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Nombre
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fecha"
                        width="150"
                        dataSort
                        dataFormat={(cell, row)=>{
                            return moment(cell).format("DD/MM/YYYY");
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Fecha
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="horas"
                        dataAlign='right'
                        headerAlign="center"
                        width="150"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Horas
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        thStyle={
                        {color: 'white'}}
                        dataField="id"
                        width="150"
                        dataAlign="center"
                        dataSort
                        dataFormat={standardActions({ 
                            ver_a: "descuento_hora",
                            editar_rrhh: "descuento_hora",
                            empresa: datosRt[5],
                            periodo: datosRt[7],
                            modulo: datosRt[4],
                        })} 
                    >
                        Acciones
                    </TableHeaderColumn>
                </Grid>
            }
            <Modal
                estado={modalReporte} //Reporte desucuento por horas
                cambiarEstado={setModalReporte}
                titulo="Listado desuentos por hora / faltas"
                botonCerrar="true"
                >
                    <Contenido>
                        <div className='col-6'>
                            <Field
                                name="anio"
                                placeholder="Año"
                                className="form-control"
                                component={renderNumber}
                                onChange={handleOnChange}
                                msj="Año"
                            />
                            {periodos &&
                                <div className='mt-2'>
                                    <Field
                                        name="periodo"
                                        options={periodos}
                                        component={SelectField}
                                        className="form-select"
                                        msj="Periodos"
                                    />
                                </div>
                            }
                            <div className="form-floating mt-2">
                                <Field
                                    name="frecuencia"
                                    options={tipoD}
                                    crear={true}
                                    dato={0}
                                    component={SelectField}
                                    className="form-select"
                                    msj="Forma descuento"
                                />
                            </div>
                        </div>
                        <div className='col-12 mb-2 mt-2'>
                            <Field
                                name="colaborador"
                                placeholder="Colaborador..."
                                className="form-control-find"
                                component={AsyncSelectField}
                                loadOptions={listarColaboradorReporte}
                                msj="Colaborador"
                            />
                        </div>
                    </Contenido>
                    <LoadMask loading={loaderRep} dark>
                        <Contenido>
                            <div className='row'>
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={reporteDescuentoHoras}
                                >
                                Generar Reporte
                                </button>
                                <button
                                    className='btn mr-2 mb-3 btn btn-secondary'
                                    onClick={() => setModalReporte(false)}
                                >
                                Cancelar
                                </button>
                            </div>
                        </Contenido>
                    </LoadMask>
            </Modal>
        </div>
    );
}

DescuentoList.propTypes = {
    data: PropTypes.object.isRequired,
    loader: PropTypes.bool.isRequired,
    onSortChange: PropTypes.func,
    loading: PropTypes.bool
};

DescuentoList.defaultProps = {
    loading: true
};
export default reduxForm({
    form: 'FormListaDescuentosHora',
})(DescuentoList);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;